import request from '@/utils/request';

//分页查询资产变更记录
export function getAssetChangePage(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/change/page',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '查询资产变更记录失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//根据资产ID获取变更记录
export function getAssetChangeListByAssetId(assetId) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/asset/change/list/${assetId}`,
			method: 'get',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '查询资产变更记录失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//资产变更统计
export function getAssetChangeStatistics(parmas) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/asset/change/statistics`,
			method: 'get',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '资产变更统计失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//新增资产变更记录
export function getAssetChangeSave(data) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/asset/change/save`,
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '新增资产变更记录失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//根据ID获取资产变更记录
export function getAssetChangeGetById(id) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/asset/change/get/${id}`,
			method: 'get',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取资产变更记录失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}
